module.exports = __webpack_public_path__ + "static/media/logo_192.2e6cf6b3.png";